import * as firebase from 'firebase/app'

const firebaseConfig = {
    apiKey: "AIzaSyBjX6tBcLVfnykbyVm6-ZTk9h7hpe_iYzo",
    authDomain: "trippy-d9090.firebaseapp.com",
    databaseURL: "https://trippy-d9090.firebaseio.com",
    projectId: "trippy-d9090",
    storageBucket: "trippy-d9090.appspot.com",
    messagingSenderId: "302161917920",
    appId: "1:302161917920:web:9065fc65e4c70ed8b09d85"
  };
  // Initialize Firebase
const old = firebase.initializeApp(firebaseConfig, 'old');
const db = firebase.database(old)

export interface OldWaypoint {
    name: string;
    address: string;
    lat: number;
    lon: number;
    index: number;
}

export interface OldRoute {
    calculated: boolean;
    creator: {
        name: string;
        uid: string;
    };
    distance: number;
    duration: number;
    name: string;
    settings: {
        breakTime: string;
        detailed: boolean;
        mapStyle: string;
        method: string;
        startTime: string;
        type: string;
        vehicle: "truck" | "car";
    };
    waypoints: {
        [placeId: string]: OldWaypoint;
    };
}


export const getOldRoute = async (routeId: string): Promise<OldRoute> => {
    const snap = await db.ref('routes').child(routeId).once('value')
    const route = snap.val() as OldRoute
    route.settings.vehicle.replace('vogn', 'truck')
    return route
}